import { forwardRef } from 'react';
import { SelectableCard, SelectableCardGroup } from '@gusto/workbench-formik';
import { CardBody, CardHeader, Grid, Heading } from '@gusto/workbench';

export enum IntentStepValues {
  YES = 'yes',
  NO = 'no',
}

const Intent = forwardRef<HTMLFieldSetElement>((_, ref) => {
  return (
    <SelectableCardGroup
      ref={ref}
      className="question"
      name="intentStep"
      label="Ready to set up your company?"
    >
      <Grid rowGap={3} columnGap={4} maxWidth={632} maxWidthMd="100%">
        <SelectableCard type="radio" aria-label="Yes" value={IntentStepValues.YES}>
          <CardHeader>
            <Heading className="answer" level={3}>
              Yes, I’m ready
            </Heading>
          </CardHeader>
        </SelectableCard>
        <SelectableCard type="radio" aria-label="No" value={IntentStepValues.NO}>
          <CardHeader>
            <Heading className="answer" level={3}>
              No, I’d like to learn more
            </Heading>
          </CardHeader>
          <CardBody className="margin-top-4x color-salt-900">
            <p>
              You&apos;ll be redirected to another page with links to pricing, our demo and several
              ways to connect with our sales team.
            </p>
          </CardBody>
        </SelectableCard>
      </Grid>
    </SelectableCardGroup>
  );
});

export default Intent;
